module.exports = __webpack_public_path__ + "img/internet.2d821c6.svg";